import { createFileRoute } from '@tanstack/react-router'
import { KestrelModelPageContent } from 'pages/kestrel/KestrelModelPage'

export const Route = createFileRoute('/kestrel/$kestrelModelId')({
  component: RouteComponent,
  staticData: {
    title: 'Kestrel Model',
  },
})

function RouteComponent() {
  const { kestrelModelId } = Route.useParams()
  return <KestrelModelPageContent kestrelModelId={kestrelModelId} />
}
